/**
 * 404 Not Found Page
 */

import { Button } from '@/shared/components/ui/button'
import { Home, Search } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="container mx-auto px-4 py-16 min-h-[60vh] flex items-center justify-center">
      <div className="text-center max-w-md">
        <h1 className="text-6xl font-bold text-muted-foreground mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-4">Página no encontrada</h2>
        <p className="text-muted-foreground mb-8">
          La página que buscas no existe o ha sido movida.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={() => void navigate('/')}>
            <Home className="h-4 w-4 mr-2" />
            Ir al inicio
          </Button>
          <Button variant="outline" onClick={() => void navigate('/professions')}>
            <Search className="h-4 w-4 mr-2" />
            Buscar profesionales
          </Button>
        </div>
      </div>
    </div>
  )
}
